import {
  IVetHorseListPageType,
  SET_ORDER,
  SET_ORDER_BY,
  SET_SEARCH_QUERY,
  SET_TRAINER_SEARCH_ITEM,
  SET_VET_LIST_HORSES_REQUEST_KEY
} from "store/actions/vetHorseListPage";
import { SortOrder } from "interfaces/SortOrder";
import { IVetHorseListPageState } from "interfaces/IVetHorseListPageState";

const initialState: IVetHorseListPageState = {
  order: SortOrder.ASC,
  orderBy: ["name"],
  searchQuery: "",
  searchTypeKey: "horses",
  trainerSearchItem: null,
  vetListHorsesRequestKey: null
};

export default (
  state = initialState,
  action: IVetHorseListPageType
): IVetHorseListPageState => {
  switch (action.type) {
    case SET_ORDER:
      return {
        ...state,
        order: action.order
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderBy: action.orderBy
      };
    case SET_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: action.searchQuery
      };
    case SET_TRAINER_SEARCH_ITEM:
      return {
        ...state,
        trainerSearchItem: action.trainerSearchItem
      };
    case SET_VET_LIST_HORSES_REQUEST_KEY:
      return {
        ...state,
        vetListHorsesRequestKey: action.vetListHorsesRequestKey
      };
    default:
      return state;
  }
};
